import { render } from "./instance-manager-resources.vue?vue&type=template&id=274ceb12"
import script from "./instance-manager-resources.vue?vue&type=script&lang=js"
export * from "./instance-manager-resources.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__